export class Path {

  public static readonly BILLING_INVOICE = {
    VALIDATE_HBL_NUMBER: "/host-utility-billing-invoice/validate",
    // SEARCH_ENTRY_NUMBER: "/host-utility-billing-invoice/validate-hbl-entry-number",
    VALIDATE_HBL_ENTRY_NUMBER: "/host-utility-billing-invoice/validate-hbl-entry-number",
    DOWNLOAD_INVOICES: "/host-utility-billing-invoice/generate-invoice",
    SEARCH_WAREHOUSE: "/host-boc-get-cfs-mapping/warehouses",
    SEARCH_WAREHOUSE_PARALLEL: "/host-boc-get-cfs-mapping/warehouses-training-team"
  };

};